/**
 * Scroll to first error
 */

import { animateScroll } from 'react-scroll';

export default function scrollToFirstError () {
    setTimeout(() => {
        let firstErrorBlock = document.querySelector('.form-invalid');
        let firstErrorBlockInput = document.querySelector('.form-invalid input');

        firstErrorBlock && animateScroll.scrollTo(window.pageYOffset + firstErrorBlock.getBoundingClientRect().top - 70);
        firstErrorBlockInput && firstErrorBlockInput.focus();
    }, 200);
}
